import { render, staticRenderFns } from "./CombineProfile.vue?vue&type=template&id=4b379a5f&scoped=true&"
import script from "./CombineProfile.vue?vue&type=script&lang=js&"
export * from "./CombineProfile.vue?vue&type=script&lang=js&"
import style0 from "./CombineProfile.vue?vue&type=style&index=0&id=4b379a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b379a5f",
  null
  
)

export default component.exports